var map = {
	"./add_photo.svg": "ff6f",
	"./add_photo_alternate.svg": "bd89",
	"./album.svg": "f7bc",
	"./allstudents.svg": "962e",
	"./arrow_back_grey.svg": "517f",
	"./arrow_drop.svg": "5731",
	"./attach.svg": "4b32",
	"./attach_file.svg": "ae61",
	"./attach_file_bai.svg": "ef20",
	"./calendar_today.svg": "1fa0",
	"./check_in.svg": "b55e",
	"./check_out.svg": "d13a",
	"./close.svg": "0572",
	"./delete-white.svg": "20f0",
	"./delete.svg": "a91f",
	"./download_black_24dp.svg": "e6bc",
	"./emoActivity.svg": "7a75",
	"./emoFlags.svg": "4ed5",
	"./emoFoods.svg": "2713",
	"./emoIcon.svg": "d4d7",
	"./emoNature.svg": "6998",
	"./emoObjects.svg": "bf72",
	"./emoPeoples.svg": "c3764",
	"./emoPlaces.svg": "ce9a",
	"./emoSymbols.svg": "fffa",
	"./icon-date.svg": "2974",
	"./icon-dele.svg": "08f3",
	"./icon-duplicate.svg": "85a8",
	"./icon-edit.svg": "1eee",
	"./important_devices.svg": "640c",
	"./info-date.svg": "9c0e1",
	"./info-person.svg": "e9b6",
	"./info-photo.svg": "afb2",
	"./info-uploaded.svg": "54d5",
	"./info.svg": "3e95",
	"./journal_add_note.svg": "f955",
	"./journal_add_photo_alternate.svg": "afb1",
	"./journal_file_add.svg": "e3303",
	"./journal_file_copy.svg": "0398",
	"./journal_file_delete.svg": "0038",
	"./journal_has_note.svg": "cb42",
	"./journal_next.svg": "30c8",
	"./journal_note_add.svg": "8754",
	"./journal_prev.svg": "d5e1",
	"./more.svg": "617f",
	"./no.svg": "1ebc",
	"./no_results.svg": "dd24",
	"./person_black_24dp.svg": "d94f",
	"./print-24px.svg": "b537",
	"./refresh_black_24dp.svg": "95b1",
	"./restore.svg": "3109",
	"./select_all.svg": "e9d7",
	"./share.svg": "40cf",
	"./star.svg": "0a83",
	"./starfilled.svg": "2e23",
	"./timeline_temperature.svg": "33d0",
	"./yes.svg": "e235"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";